import axios from "fetch-api/fetch-api";

export interface RecommendationItem {
  description: string;
  img_link: string;
  page_link: string;
}

export interface RecommendationGroup {
  rank: number;
  key: string;
  title: string;
  items: RecommendationItem[];
}

export interface RecommendationsResponse {
  page_type: string;
  recommendation_groups: RecommendationGroup[];
}

export interface RecommendationsPayload {
  page_type: string;
  is_logged_in: boolean;
  fsa: string;
  vehicles: Array<{
    make: string;
    model: string;
    year: number;
  }>;
  locale: string;
}

let cachedPayloadKey: string | null = null;
let cachedResponse: Promise<{ data: RecommendationsResponse }> | null = null;

export default function getRecommendationsApi(payload: RecommendationsPayload) {
  const payloadKey = JSON.stringify(payload);

  if (cachedPayloadKey === payloadKey && cachedResponse) {
    return cachedResponse;
  }

  cachedPayloadKey = payloadKey;
  cachedResponse = axios.post<RecommendationsResponse>(
    "/p-products/recommendations",
    payload,
  );

  cachedResponse.catch(() => {
    cachedPayloadKey = null;
    cachedResponse = null;
  });

  return cachedResponse;
}
